<template>
  <button
    :class="`
    chip
    font-cera-pro
    text-midnight flex
    items-center
    py-2.5 px-4
    rounded cursor-pointer
    ${variantClasses}
    `"
    @click="onClick"
    :data-test-is-active="active"
    ref="container"
  >
    <sprite :id="`category/${sprite}`" class="w-6 h-6 mr-2 whitespace-normal chip__sprite text-midnight" />
    <span :class="labelClasses">
      {{ label }}
    </span>
  </button>
</template>

<script>
import Sprite from "@/shared/sprite"

const VARIANTS_STYLE = {
  default: {
    base: "border-2 border-solid",
    active: "border-green",
    normal: "border-white m:hover:border-green"
  },
  yellow: {
    base: "",
    active: "bg-summer-yellow-6",
    normal: "bg-background-yellow m:hover:bg-summer-yellow-6"
  }
}

const VARIANTS = Object.keys(VARIANTS_STYLE)

export default {
  name: "Chip",
  components: { Sprite },
  props: {
    sprite: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: "bg-white"
    },
    labelClasses: {
      type: String,
      default: "block whitespace-nowrap"
    },
    variant: {
      type: String,
      default: "default",
      validator: (value) => VARIANTS.includes(value)
    }
  },
  computed: {
    variantClasses() {
      const variantStyles = VARIANTS_STYLE[this.variant]

      const styles = [variantStyles.base]
      if (this.active) {
        styles.push(variantStyles.active)
      } else {
        styles.push(variantStyles.normal)
      }

      if (this.variant !== "yellow") {
        styles.push(this.backgroundColor)
      }

      return styles.join(" ")
    }
  },
  methods: {
    onClick(e) {
      e.preventDefault()
      this.$emit("click", this.slug)
    }
  }
}
</script>
